module.exports = __webpack_public_path__ + "static/media/6_Prepare-Back-Cable-WiresInConnector.a3fb0d77.svg";